/**
 * 検索用の文字列正規化。
 * 検索ロジックとタクソノミーの両方から使うため、1か所にまとめている。
 * （以前は search.ts と taxonomy.ts に同じ実装が二重に存在していた）
 */

/** NFKC → 小文字化 → カタカナ→ひらがな → 空白除去 */
export function normalizeText(input: string): string {
  if (!input) return "";
  return input
    .normalize("NFKC")
    .toLowerCase()
    .replace(/[\u30a1-\u30f6]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 0x60))
    .replace(/[\s\u3000]+/g, "");
}

/** 半角/全角スペース区切りでトークン化し、正規化する */
export function splitQuery(query: string): string[] {
  return query
    .split(/[\s\u3000]+/)
    .map((token) => normalizeText(token))
    .filter(Boolean);
}

/** 検索候補の重複排除などに使う安定キー */
export function dedupeKey(...parts: string[]): string {
  return parts.join("\u0000");
}